import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { MatterOverageDNSDto } from '@/models/audit/MatterOverageDNSDto'
import { MatterWorkDto } from '@/models/matter-work/MatterWorkDto';
import { MatterWorkMatterDto } from '@/models/matter-work/MatterWorkMatterDto';

@Module({ name: 'matter-work' })
export default class MatterWorkModule extends VuexModule {
    private matterOverageDNS: MatterOverageDNSDto[] | null = [];
    private selectedMatter: MatterWorkMatterDto | null = null;
    private selectedMatterId: Guid | null = null;
    private activeBatchIds: Guid[] | null = [];

    @Mutation
    protected SET_MATTER_OVERAGE_DNS(matterOverageDNS: MatterOverageDNSDto[]): void {
      this.matterOverageDNS = matterOverageDNS;
    }

    public get matterOverageDoNotSend(): MatterOverageDNSDto[] | null {
        return this.matterOverageDNS;
    }

    @Action({ commit: 'SET_MATTER_OVERAGE_DNS' })
    public async setMatterOverageDNS(matterOverageDNS: MatterOverageDNSDto[] | null): Promise<MatterOverageDNSDto[] | null> {
        return matterOverageDNS;
    }

    @Mutation
    protected SET_SELECTED_MATTER(matterWorkMatterDto: MatterWorkMatterDto | null): void {
      this.selectedMatter = matterWorkMatterDto;
    }

    public get selectMatter(): MatterWorkMatterDto | null {
        return this.selectedMatter;
    }

    @Action({ commit: 'SET_SELECTED_MATTER' })
    public async setSelectedMatter(matterWorkMatterDto: MatterWorkMatterDto | null): Promise<MatterWorkMatterDto | null> {
        return matterWorkMatterDto;
    }

    @Mutation
    protected SET_SELECTED_MATTER_ID(matterId: Guid | null): void {
        this.selectedMatterId = matterId;
    }

    public get selectMatterId(): Guid | null {
        return this.selectedMatterId;
    }

    @Action({ commit: 'SET_SELECTED_MATTER_ID' })
    public async setSelectedMatterId(matterId: Guid | null): Promise<Guid | null> {
        return matterId;
    }

    @Mutation
    protected SET_ACTIVE_BATCH_IDS(batchIds: Guid[] | null): void {
        this.activeBatchIds = batchIds;
    }

    public get activeBatches(): Guid[] | null {
        return this.activeBatchIds;
    }

    @Action({ commit: 'SET_ACTIVE_BATCH_IDS'})
    public async setActiveBatchIds(batchIds: Guid[] | null): Promise<Guid[] | null> {
        return batchIds;
    }    
}
